// eslint-disable-next-line no-restricted-imports
import { createRouter, createWebHistory } from 'vue-router'

import { addRouterNavigationGuards } from './router-utils.ts'
import { routes } from './routes.ts'

export const routerInstance = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

addRouterNavigationGuards(routerInstance)
